//#region react import
import { useState } from "react";
import { useSelector } from "react-redux";
//#endregion

//#region component import
import AcreosNavigation from "../../Components/AcreosNavigation/AcreosNavigation.component";
import DocumentationModal from "../../Components/DocumentationModal/DocumentationModal.component";
import LogoutButton from "../../Components/LogoutButton/LogoutButton.component";
import QuestionnaryChip from "../../Components/QuestionnaryChip/QuestionnaryChip.component";
import QuestionnaryModal from "../../Components/QuestionnaryModal/QuestionnaryModal.component";
import UserChip from "../../Components/UserChip/UserChip.component";
//#endregion

//#region function import
import useDocumentTitle from "../../Helper/CustomHook/useDocumentTitle";
import { getTranslations } from "../../Helper/TranslationController";
//#endregion

//#region constants import
import packageJson from "../../../package.json";
import {
  ICON_CONVERSION_PATH,
  ICON_GROUPS,
  ICON_HOME,
  ICON_LOCATION_ON,
  ICON_LOGO_GSTA,
  ICON_PERSON,
  NAVIGATION_BUTTON_ICON,
  TEXT_ICON,
} from "../../Constants/IconConstants";
import { poweredbyAcreos } from "../../Constants/Images";
import {
  CENTER,
  CENTER_SIMULATORS,
  CURRENT_ACTIVITY,
  HOME,
  PROFIL,
  SELECT_ACTIVE_CENTER,
  STUDENTS,
  TRAININGS,
} from "../../Routing/PageNames";
//#endregion

//#region style import
import "./GlobalLayout.style.scss";
//#endregion

const GlobalLayout = ({ icon, children, title }) => {
  //#region useSelector
  const translations = useSelector((state) => state.translationSlice.translations);
  const activeCenterName = useSelector((state) => state.connexionSlice.trainer?.activeCenter?.name);
  const isLocalInstallation = useSelector((state) => state.settingSlice.isLocalInstallation);
  //#endregion

  //#region useState
  const [questionnaryModalOpen, setQuestionnaryModalOpen] = useState(false);
  //#endregion

  const dataSettingsMenuLandscape = [
    {
      key: 0,
      overrideComponent: (
        <div className="gsta-navigation-logo">
          <i className={ICON_LOGO_GSTA} />
          <img
            className="navigation-bar-powered-by-acreos"
            src={process.env.PUBLIC_URL + poweredbyAcreos.img}
            alt={poweredbyAcreos.alt}
          />
        </div>
      ),
    },
    {
      key: 1,
      iconClass: `${ICON_HOME} ${NAVIGATION_BUTTON_ICON}`,
      url: CURRENT_ACTIVITY.url,
      matchingUrl: HOME.matchingUrl,
      title: getTranslations(HOME.pageTraductionKey, translations),
    },
    {
      key: 2,
      iconClass: `${ICON_GROUPS} ${NAVIGATION_BUTTON_ICON}`,
      url: STUDENTS.url,
      matchingUrl: STUDENTS.matchingUrl,
      title: getTranslations(STUDENTS.pageTraductionKey, translations),
    },
    {
      key: 3,
      iconClass: `${ICON_CONVERSION_PATH} ${NAVIGATION_BUTTON_ICON}`,
      url: TRAININGS.url,
      matchingUrl: TRAININGS.matchingUrl,
      title: getTranslations(TRAININGS.pageTraductionKey, translations),
    },
    {
      key: 4,
      iconClass: `${ICON_LOCATION_ON} ${NAVIGATION_BUTTON_ICON}`,
      url: !process.env.REACT_APP_LOCAL ? SELECT_ACTIVE_CENTER.url : CENTER_SIMULATORS.url,
      matchingUrl: CENTER.matchingUrl,
      title: getTranslations(CENTER.pageTraductionKey, translations),
      subTitle: !process.env.REACT_APP_LOCAL ? activeCenterName : null,
    },
    {
      key: 5,
      iconClass: `${ICON_PERSON} ${NAVIGATION_BUTTON_ICON}`,
      url: PROFIL.url,
      title: getTranslations(PROFIL.pageTraductionKey, translations),
    },
    {
      key: 6,
      overrideComponent: <LogoutButton />,
    },
  ];

  useDocumentTitle("GSTA Pro " + getTranslations(title, translations));

  return (
    <div className="global-layout">
      <div className="version">V.{packageJson.buildVersion}</div>
      <AcreosNavigation
        maxNavElement={7}
        navData={dataSettingsMenuLandscape}
        structureClass={"new-gsta-navigation landscape"}
        overrideCustomLinkClass={"gsta-navigation-link"}
      />
      <header className="title-fixed">
        <h1 className={TEXT_ICON}>
          <i className={`icon-${icon}`} />
          <span>{getTranslations(title, translations)}</span>
        </h1>
        <section>
          {!isLocalInstallation && <QuestionnaryChip setModalOpen={() => setQuestionnaryModalOpen(true)} />}
          <DocumentationModal />
          <UserChip />
        </section>
      </header>
      <section>{children}</section>
      {questionnaryModalOpen && (
        <QuestionnaryModal
          isModalOpen={questionnaryModalOpen}
          closeModal={() => {
            setQuestionnaryModalOpen(false);
          }}
        />
      )}
    </div>
  );
};

export default GlobalLayout;
